import React from "react"

import { cn } from "@/lib/utils"
import BasicCard from "@/components/common/BasicCard"

export default function FallbackCard(props: { className?: string }) {
  return <BasicCard className={cn("animate-pulse bg-gray-200", props.className)} />
}
